import { styled } from '@mui/material';
import { SelectMenu } from '../../atoms/SelectMenu';

export const StyledSelectMenu = styled(SelectMenu)`
  width: 100%;
`;
